//Entry file into all index
import {createApp} from "vue";
import LoginForm from "./components/LoginForm.vue";
import PasswordResetForm from "./components/PasswordResetForm.vue";
import DispatchDashboard from "./components/DispatchDashboard.vue";
import AdminDashboard from "./components/AdminDashboard.vue";
import ServiceProviderDetail from "./components/ServiceProviderDetail.vue";
import ServiceConfiguration from "./components/ServiceConfiguration.vue";
import UserProfile from "./components/UserProfile.vue";
import DispatchCallHandler from "./components/DispatchCallHandler.vue";
import CallHistoryNotification from "./components/CallHistoryNotification.vue";
import AllServiceProviderRides from "./components/AllServiceProviderRides.vue";
import RideDetail from "./components/RideDetail.vue"
import DriverDetail from "./components/DriverDetail.vue";
import DispatchUserDetail from "./components/DispatchUserDetail.vue";
import AllServiceProviderDrivers from "./components/AllServiceProviderDrivers.vue";
import AllServiceProviderDispatchUsers from "./components/AllServiceProviderDispatchUsers.vue";
import DispatchUserOnboardingForm from "./components/DispatchUserOnboardingForm.vue";
import DriverUserOnboardingForm from "./components/DriverUserOnboardingForm.vue";
import GeoZones from "./components/GeoZones.vue";
import GeoZoneDetail from "./components/GeoZoneDetail.vue";
import DriverPublicProfile from "./components/DriverPublicProfile.vue";
import DriverVehicleLicenseManagement from "./components/DriverVehicleLicenseManagement.vue";
import DriverSubscriptionManagement from "./components/DriverSubscriptionManagement.vue";
import DashboardMetrics from "./components/DashboardMetrics.vue";
import AccountsList from "./components/AccountsList.vue";
import AccountDetail from "./components/AccountDetail.vue";
import AllIndependentDrivers from "./components/AllIndependentDrivers.vue";
import IndependentDriverSignupForm from "./components/IndependentDriverSignupForm.vue";
import ServiceJurisdictions from "./components/ServiceJurisdictions.vue";
import ServiceJurisdictionDetail from "./components/ServiceJurisdictionDetail.vue";
import DriverApplicationStatus from "./components/DriverApplicationStatus.vue";
import SharedRideStatus from "./components/SharedRideStatus.vue";
import PortalChooser from "./components/PortalChooser.vue";
import RiderWaitlistPortal from "./components/RiderWaitlistPortal.vue";
import RiderWaitlistStatus from "./components/RiderWaitlistStatus.vue";
import DriverLogin from "./components/DriverLogin.vue";
import Shifts from "./components/Shifts.vue";
import ShiftDetail from "./components/ShiftDetail.vue";
import ShiftsCalendar from "./components/ShiftsCalendar.vue";
import TaxReserve from "./components/TaxReserve.vue";
import DriverTaxRegistrations from "./components/DriverTaxRegistrations.vue";
import InsuranceExposureReport from "./components/InsuranceExposureReport.vue";
import ReserveDashboard from "./components/ReserveDashboard.vue";
import Wallets from "./components/Wallets.vue";
import WalletDetail from "./components/WalletDetail.vue";
import WalletApprovalQueue from "./components/WalletApprovalQueue.vue";

window.Vue = {
    createApp,
    LoginForm,
    PasswordResetForm,
    DispatchDashboard,
    AdminDashboard,
    ServiceProviderDetail,
    ServiceConfiguration,
    UserProfile,
    DispatchCallHandler,
    CallHistoryNotification,
    AllServiceProviderRides,
    RideDetail,
    DispatchUserDetail,
    DriverDetail,
    AllServiceProviderDrivers,
    AllServiceProviderDispatchUsers,
    DispatchUserOnboardingForm,
    DriverUserOnboardingForm,
    GeoZones,
    GeoZoneDetail,
    DriverPublicProfile,
    DriverVehicleLicenseManagement,
    DriverSubscriptionManagement,
    DashboardMetrics,
    AccountsList,
    AccountDetail,
    AllIndependentDrivers,
    IndependentDriverSignupForm,
    ServiceJurisdictions,
    ServiceJurisdictionDetail,
    DriverApplicationStatus,
    SharedRideStatus,
    PortalChooser,
    RiderWaitlistPortal,
    RiderWaitlistStatus,
    DriverLogin,
    Shifts,
    ShiftDetail,
    ShiftsCalendar,
    TaxReserve,
    DriverTaxRegistrations,
    InsuranceExposureReport,
    ReserveDashboard,
    Wallets,
    WalletDetail,
    WalletApprovalQueue
};


// Auto-mount any component declared via data-vue-component / data-vue-props attributes
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-vue-component]').forEach(el => {
        const name = el.dataset.vueComponent;
        const props = el.dataset.vueProps ? JSON.parse(el.dataset.vueProps) : {};
        const component = window.Vue[name];
        if (!component) return;
        createApp(component, props).mount(el);
    });
});

// Sidebar script
import '../extras/js/sidebar.js';
import '../extras/js/scrollbar/sidebar-scroll.js'
import '../extras/js/height-equal.js';
import '../extras/js/password';
// Custom script
import '../extras/js/script.js';
